import React, { useCallback, useEffect, useState } from 'react';
import InputField from '../../component/form/FormInput';
import Button from '../../component/ui/Button';
import InputSelect from '../../component/inputSelect/InputSelect';
import { useBlocker, useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchVendors } from '../../services/vendor';
import { fetchPurchaseBillByVendorId } from '../../services/purchase_bill';
import { getCurrentDate, getDate } from '../../utils/dateUtils';
import tooltipIcon from '../../assets/image/tooltip_vendor name.png';
import OpenPOAlert from '../../assets/image/Open PO Alert.svg';
import {
	create_payment_made,
	fetchPaymentMadeDetails,
	fetchPaymentMadeNumber,
	update_payment_made,
} from '../../services/payment_made';
import AppendInput from '../../component/form/AppendInput';
import { toast } from 'react-toastify';
import Modal from '../../component/modal/Modal';
import VendorDetailsDrawer from '../purchaseOrder/components/VendorDetailsDrawer';
import AddVendorModal from '../purchaseOrder/AddNewVendor';
import { createPaymentMethod, fetchPaymentMethodList } from '../../services/payment_methods';
import PaymentMadeProductTable from './components/paymentMadeProductTable';
import { useSelector } from 'react-redux';
import { hasPermission } from '../../utils/controller';
import AutoSaveModal from '../components/autoSaveModal';

const CreatePaymentMade = () => {
	const suburl = localStorage.getItem('suburl');
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const navigate = useNavigate();
	const param = useParams();
	const id = param?.id;
	const [autofocus, setAutofocus] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [isLoader, setLoader] = useState(false);
	const [paymentAmount, setPaymentAmount] = useState('');
	const [searchPaymentMethod, setSearchPaymentMethod] = useState('');
	const [inputSelectOption, setInputSelectOption] = useState({
		vendorList: [],
	});
	const location = useLocation();
	const [error, setError] = useState({});
	const [errorCells, setErrorCells] = useState([]);
	const [errorPaymentMethod, setErrorPaymentMethod] = useState('');
	const [paymentMode, setPaymentMode] = useState('');
	const [paymentMethodList, setPaymentMethodList] = useState([]);
	const [paymentMethodParams, setPaymentMethodParams] = useState({
		page: 1,
		limit: 20,
		search: '',
	});
	const [params, setParams] = useState({
		vendor: {
			status: 1,
			page: 1,
			pageSize: 20,
			orderBy: null,
			sortBy: null,
			filterBy: null,
			filterValue: null,
			filter: {
				status: '1',
			},
		},
	});
	const [isPaymentMethodFocus, setIsPaymentMethodFocus] = useState(false);
	const [isAddPaymentMethod, setIsAddPaymentMethod] = useState(false);
	const [paymentMadeFormData, setPaymentMadeFormData] = useState({
		vendor_id: null,
		payment_number: '',
		payment_amount: '',
		date: getCurrentDate(),
		payment_mode: '',
		reference_number: '',
		purchase_bills: [],
	});
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isPaymentModeAutoSave, setIsPaymentModeAutoSave] = useState(false);
	const [isAddNewVendorModalOpen, setIsAddNewVendorModalOpen] = useState(false);
	const [isOpenPastDate, setIsOpenPastDate] = useState(false);
	const [isUsedPastDate, setIsUsedPastDate] = useState(false);
	const [vendorDetailsDrawerActiveOpenTab, setVendorDetailsDrawerActiveOpenTab] = useState('');
	const [isVendorDetailsDrawerOpen, setIsVendorDetailsDrawerOpen] = useState(false);
	const [projectTitle, setProjectTitle] = useState('Create New Payment Made');
	const confirmUsedPastDate = () => {
		const newError = { ...error };
		delete newError.date;
		setError(newError);
		setIsUsedPastDate(true);
		setIsOpenPastDate(false);
		setIsPaymentMethodFocus(true);
	};

	const cancelUsedPastDate = () => {
		setIsOpenPastDate(false);
		setIsPaymentMethodFocus(true);
	};

	const handlePaymentChange = (index, value) => {
		const paymentBillsData = [...paymentMadeFormData.purchase_bills];
		paymentBillsData[index].paid_amount = value;
		setPaymentMadeFormData((prev) => ({
			...prev,
			purchase_bills: paymentBillsData,
		}));
		const isValid = Number(paymentBillsData[index].due_amount) >= Number(value);
		setErrorCells((prev) => {
			const filtered = prev.filter((error) => error.index !== index);

			return isValid ? filtered : [...filtered, { index, error: 'Invalid Payment' }];
		});
	};

	const handleFullPaymentToggle = (index, type) => {
		if (type === 'pay') {
			const paymentBillsData = [...paymentMadeFormData.purchase_bills];
			paymentBillsData[index].paid_amount = paymentBillsData[index].due_amount;
			setPaymentMadeFormData((prev) => ({
				...prev,
				purchase_bills: paymentBillsData,
			}));
		} else {
			const paymentBillsData = [...paymentMadeFormData.purchase_bills];
			paymentBillsData[index].paid_amount = '';
			setPaymentMadeFormData((prev) => ({
				...prev,
				purchase_bills: paymentBillsData,
			}));
		}
	};

	const calculateTotalPayment = () => {
		return paymentMadeFormData?.purchase_bills?.reduce(
			(total, bill) => Number(total) + Number(bill.paid_amount),
			0,
		);
	};

	const navigateRouter = (path) => {
		navigate(path);
	};

	function handleKeyPress(name, e) {
		let { value } = e.target;
		var valueData = value?.replace(/[^0-9.]/g, '');
		if (e.key === 'Enter' || e.key === 'Tab') {
			handleFormData(name, valueData);
		}
	}

	function handleFormData(key, value) {
		setPaymentMadeFormData((prev) => ({
			...prev,
			[key]: value,
		}));
		if (key === 'payment_amount') {
			setPaymentAmount(value);
		}
		let errorData = { ...error };
		if (
			key === 'payment_amount' &&
			(value === '' || value === null || value === undefined || Number(value) === 0)
		) {
			errorData.payment_amount = 'Please enter payment amount in the field';
		} else if (key === 'payment_amount' && value !== '' && value !== null) {
			delete errorData.payment_amount;
		}

		if (key === 'vendor_id' && (value === '' || value === null)) {
			errorData.vendor_id = 'Please select a valid vendor in the list';
		} else if (key === 'vendor_id' && (value !== '' || value !== null)) {
			delete errorData.vendor_id;
		}

		if (key === 'payment_number' && (value === '' || value === null)) {
			errorData.payment_number = 'Please enter payment number in the field';
		} else if (key === 'payment_number' && (value !== '' || value !== null)) {
			delete errorData.payment_number;
		}

		if (key === 'date' && (value === '' || value === null)) {
			errorData.date = 'Please enter date in the field';
		} else if (key === 'date' && (value !== '' || value !== null)) {
			delete errorData.date;
		}

		if (key === 'payment_mode' && (value === '' || value === null)) {
			errorData.payment_mode = 'Please select a valid payment made in the list';
		} else if (key === 'payment_mode' && (value !== '' || value !== null)) {
			delete errorData.payment_mode;
		}
		setError(errorData);
	}

	function handleClearAppliedAmount() {
		if (isDisabled) return;
		const paymentBillsData = paymentMadeFormData.purchase_bills.map((item) => ({
			...item,
			paid_amount: '',
		}));
		setPaymentMadeFormData((prev) => ({
			...prev,
			purchase_bills: paymentBillsData,
		}));
	}

	async function handleFetchPurchaseBillByVendorId(vendor_id) {
		//TODO: add api to fetch purchase bill that is open / partially paid by vendor_id
		const purchaseBills = await fetchPurchaseBillByVendorId(vendor_id);

		setPaymentMadeFormData((prev) => ({
			...prev,
			vendor_id: vendor_id,
			purchase_bills: purchaseBills?.map((pb) => ({
				purchase_bill_id: pb?.purchase_bill_id,
				date: pb?.bill_date,
				due_date: pb?.due_date,
				bill_number: pb.bill_number,
				purchase_order_number:
					pb.purchase_order_number || pb?.purchase_order?.purchase_order_number || 'N/A',
				bill_amount: pb.bill_amount,
				due_amount: pb.due_amount,
				paid_amount: '',
			})),
		}));
	}

	function checkValidation() {
		const newError = { ...error };
		if (
			!paymentMadeFormData.vendor_id ||
			paymentMadeFormData.vendor_id === '' ||
			paymentMadeFormData.vendor_id === undefined
		) {
			newError.vendor_id = 'Please select a valid vendor from the list.';
		} else {
			delete newError.vendor_id;
		}
		if (
			!paymentMadeFormData.payment_number ||
			paymentMadeFormData.payment_number === '' ||
			paymentMadeFormData.payment_number === undefined
		) {
			newError.payment_number = 'Please enter payment number in the field';
		} else {
			delete newError.payment_number;
		}
		if (
			!paymentMadeFormData.date ||
			paymentMadeFormData.date === '' ||
			paymentMadeFormData.date === undefined ||
			(paymentMadeFormData.date !== '' && newError.date)
		) {
			newError.date = newError.date ?? 'Please enter date in the field';
		} else {
			delete newError.date;
		}
		if (
			!paymentMadeFormData.payment_amount ||
			paymentMadeFormData.payment_amount === '' ||
			paymentMadeFormData.payment_amount === undefined ||
			(paymentMadeFormData.payment_amount !== '' && newError.payment_amount)
		) {
			newError.payment_amount =
				newError.payment_amount ?? 'Please enter payment amount in the field';
		} else {
			delete newError.payment_amount;
		}
		if (
			!paymentMadeFormData.payment_mode ||
			paymentMadeFormData.payment_mode === '' ||
			paymentMadeFormData.payment_mode === undefined
		) {
			newError.payment_mode = 'Please select a payment mode from the list.';
		} else {
			delete newError.payment_mode;
		}
		if (
			Object.keys(newError).length > 0 ||
			Number(paymentAmount) !== calculateTotalPayment() ||
			errorCells.length > 0
		) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	async function handleSavePaymentMade() {
		const checkError = checkValidation();
		if (checkError) {
			if (Number(paymentAmount) !== calculateTotalPayment()) {
				toast.error('Please enter payment less than or equal to payment amount');
			} else {
				toast.error('Unable to create or update payment made');
			}
		} else {
			try {
				setLoader(true);
				if (id) {
					await update_payment_made(id, paymentMadeFormData);
					toast.success('Payment Made updated successfully.');
				} else {
					await create_payment_made(paymentMadeFormData);
					toast.success('Payment Made created successfully.');
				}
				setIsLocationBlocker(false);
				setIsPaymentModeAutoSave(false);
				setTimeout(() => {
					navigateRouter(`/user/${suburl}/payment-made`);
				}, 300);
			} catch (error) {
				toast.error('Something went wrong!');
			} finally {
				setLoader(false);
			}
		}
	}

	const handleFetchPaymentMethod = useCallback(async () => {
		try {
			const data = await fetchPaymentMethodList(paymentMethodParams);
			const paymentMethodOptionList = data?.paymentMethods?.map((pm) => {
				return {
					key: pm?.payment_method_name,
					value: pm?.payment_method_name,
				};
			});
			if (paymentMadeFormData.payment_mode) {
				const isPaymentMode = paymentMethodOptionList.find(
					(data) => data.value === paymentMadeFormData.payment_mode,
				);
				if (!isPaymentMode) {
					setPaymentMethodParams((prev) => ({
						...prev,
						search: paymentMadeFormData.payment_mode,
					}));
				}
			} else {
				setPaymentMethodList(paymentMethodOptionList);
			}
		} catch (error) {
			toast.error('Something went wrong');
		}
	}, [paymentMethodParams]);

	const handleAddPaymentMethod = async () => {
		try {
			if (paymentMode === '') {
				setErrorPaymentMethod('Please enter payment method name!');
			}
			const data = await createPaymentMethod({ payment_method_name: paymentMode });

			setPaymentMethodList([
				...paymentMethodList,
				{
					key: data.paymentMethod?.payment_method_name,
					value: data.paymentMethod?.payment_method_name,
				},
			]);
			setPaymentMadeFormData((prev) => ({
				...prev,
				payment_mode: data.paymentMethod?.payment_method_name,
			}));
			setIsAddPaymentMethod(false);
			setIsPaymentMethodFocus(true);
		} catch (error) {
			toast.error('Something went wrong!');
		}
	};

	const handleFetchPaymentMadeDetails = useCallback(async () => {
		const data = await fetchPaymentMadeDetails(id);
		setPaymentMadeFormData({
			payment_made_id: data?.payment_made_id,
			vendor_id: data?.vendor_id,
			payment_number: data?.payment_number,
			payment_amount: data?.payment_amount,
			date: getDate(data?.date, true),
			payment_mode: data?.payment_mode,
			reference: data?.reference_number,
			purchase_bills: data?.purchase_bill_payment_made?.map((pb) => {
				return {
					purchase_bill_id: pb?.purchase_bill?.purchase_bill_id,
					date: pb?.purchase_bill?.bill_date,
					due_date: pb?.purchase_bill?.due_date,
					bill_number: pb?.purchase_bill?.bill_number,
					purchase_order_number:
						pb?.purchase_bill?.purchase_order_number ||
						pb?.purchase_bill?.purchase_order?.purchase_order_number,
					bill_amount: Number(pb?.purchase_bill?.bill_amount).toFixed(2),
					due_amount: Number(pb?.purchase_bill?.due_amount).toFixed(2),
					paid_amount: Number(pb?.payment_amount).toFixed(2),
				};
			}),
		});
		setPaymentAmount(data?.payment_amount);
		setIsDisabled(true);
	}, [id]);

	const handleFetchSearchVendor = useCallback(async () => {
		try {
			const data = await fetchVendors(params?.vendor);

			const vendorOptionList = data.vendors.map((vendor) => {
				return {
					key: vendor?.vendor_id,
					value: vendor?.vendor_name,
				};
			});

			setInputSelectOption((prev) => ({
				...prev,
				vendorList: vendorOptionList,
			}));
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}, [params.vendor]);

	useEffect(() => {
		if (!paymentMadeFormData.vendor_id) {
			handleFetchSearchVendor();
		}
	}, [params.vendor, id, paymentMadeFormData.vendor_id]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setPaymentMethodParams((prev) => ({
				...prev,
				search: searchPaymentMethod,
			}));
		}, 500);
		return () => clearTimeout(timer);
	}, [searchPaymentMethod]);

	useEffect(() => {
		handleFetchPaymentMethod();
	}, [paymentMethodParams?.search]);

	useEffect(() => {
		if (id) {
			if (id.includes('vendor_id')) {
				const vendor_id = id.split('-')[1];
				handleFetchPurchaseBillByVendorId(vendor_id);
			} else {
				handleFetchPaymentMadeDetails();
				setProjectTitle('Update Payment Made');
			}
		}

		if (!id) {
			async function handleFetchPaymentMadeNumber() {
				const payment_made_number = await fetchPaymentMadeNumber();
				handleFormData('payment_number', payment_made_number);
			}
			handleFetchPaymentMadeNumber();
		}
	}, [id]);

	function setVendorData() {
		if (location && location?.state) {
			const state = location?.state;
			setInputSelectOption((prev) => ({
				...prev,
				vendorList: [{ key: state.key, value: state.value }],
			}));
			setPaymentMadeFormData((prev) => ({
				...prev,
				vendor_id: state?.key,
			}));
			handleFetchPurchaseBillByVendorId(state?.key);
		}
	}

	useEffect(() => {
		if (location && location?.state) {
			setVendorData();
		}
	}, [location]);

	useEffect(() => {
		document.title = `${projectTitle} | Pharmnex`;
	}, [projectTitle]);

	useBlocker((tx) => {
		if (!id && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsPaymentModeAutoSave(true);
			return true;
		}
		return false;
	});
	useEffect(() => {
		if (!autofocus) {
			setAutofocus(true);
		}
	}, [autofocus]);

	return (
		<div>
			{/* Header Section */}
			<div className="product-pg-header add-product header-position-sticky">
				<p>{id ? 'Update Payment Made' : 'Create New Payment Made'}</p>
				<div className="add-product-button">
					<Button
						type="button"
						className="btn-primary mt-0 px-4"
						disabled={
							isLoader
								? true
								: id
									? !hasPermission('purchases.payments_made.edit', user?.role?.role_permissions)
									: !hasPermission('purchases.payments_made.create', user?.role?.role_permissions)
						}
						button="Save"
						loader={isLoader}
						onClick={() => {
							setIsPaymentModeAutoSave(false);
							handleSavePaymentMade();
						}}
					/>
					<Button
						type="button"
						className="mt-0 btn-danger add-pro"
						button=""
						close
						onClick={() => navigateRouter(`/user/${suburl}/payment-made`)}
					/>
				</div>
			</div>

			{/* Vendor Form Section */}
			<div className="max-w-1297 px-3 py-3">
				<div className="row">
					<div className="col-6">
						<InputSelect
							options={inputSelectOption?.vendorList}
							label="Vendor Name"
							placeholder="Vendor Name"
							required={true}
							error={error?.vendor_id}
							value={paymentMadeFormData?.vendor_id}
							returnInputValue={false}
							onChange={(value) => {
								if (value === '') {
									handleFormData('vendor_id', value);
								}
								setParams((prev) => ({
									...prev,
									vendor: {
										...prev.vendor,
										filterBy: 'vendor_name',
										filterValue: value,
										status: 1,
									},
								}));
							}}
							onSelect={(option) => {
								handleFormData('vendor_id', option.key);
								handleFetchPurchaseBillByVendorId(option.key);
							}}
							autoFocus={isDisabled ? false : autofocus}
							leftIcons={
								paymentMadeFormData?.vendor_id
									? [
										{
											src: OpenPOAlert,
											alt: 'showVendorDetails',
											onClick: () => {
												setVendorDetailsDrawerActiveOpenTab('Open POs');
												setIsVendorDetailsDrawerOpen(true);
											},
										},
										{
											src: tooltipIcon,
											alt: 'Icon 2',
											onClick: () => {
												setVendorDetailsDrawerActiveOpenTab('Details');
												setIsVendorDetailsDrawerOpen(true);
											},
										},
									]
									: []
							}
							onAddNew={() => setIsAddNewVendorModalOpen(true)}
							className="labelClass"
						/>
					</div>
					<div className="col">
						<InputField
							label="Payment#"
							placeholder="PM-008"
							disabled={true}
							value={paymentMadeFormData.payment_number}
							required={true}
							onKeyPress={(e) => handleKeyPress('payment_number', e)}
							onChange={(value) => handleFormData('payment_number', value)}
							error={error?.payment_number}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-6">
						<AppendInput
							label="Payment Amount"
							placeholder="Amount"
							appendLabel="INR"
							required={true}
							type="text"
							onKeyPress={(e) => handleKeyPress('payment_amount', e)}
							className="custom-append-text"
							error={error?.payment_amount}
							value={paymentMadeFormData?.payment_amount}
							onChange={(valueData) => {
								var value = valueData?.replace(/[^0-9.]/g, '');
								handleFormData('payment_amount', value);
							}}
						/>
					</div>
					<div className="col-6">
						<InputField
							label="Date"
							placeholder="Date"
							type="date"
							max={getCurrentDate()}
							required={true}
							error={error?.date}
							value={paymentMadeFormData.date}
							onBlur={(e) => {
								let value = e.target.value;
								const newError = { ...error };
								var date = new Date(value);
								var currentDate = new Date();
								currentDate.setDate(currentDate.getDate() + 1);
								let year = date.getFullYear().toString();
								if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
									if (!isUsedPastDate) {
										setIsOpenPastDate(true);
										newError.date = 'Date cannot be in the past.';
										setError(newError);
									} else {
										delete newError.date;
										setError(newError);
									}
									setPaymentMadeFormData((prev) => ({
										...prev,
										date: value,
									}));
								} else if (
									year.length === 4 &&
									new Date(value) > currentDate.setHours(0, 0, 0, 0)
								) {
									newError.date = 'Date cannot be in the future';
									setError(newError);
									setPaymentMadeFormData((prev) => ({
										...prev,
										date: value,
									}));
								} else {
									delete newError.date;
									setError(newError);
									setPaymentMadeFormData((prev) => ({
										...prev,
										date: value,
									}));
								}
							}}
							onChange={(value) => {
								setPaymentMadeFormData((prev) => ({
									...prev,
									date: value,
								}));
							}}
						/>
					</div>
				</div>
				<div
					className="row"
					style={{ marginTop: '10px' }}
				>
					<div className="col-6">
						<InputSelect
							options={paymentMethodList}
							label="Payment Method"
							placeholder="Payment Method"
							required={true}
							autoFocus={isPaymentMethodFocus}
							value={paymentMadeFormData.payment_mode}
							onChange={(value) => {
								if (value === '') {
									handleFormData('payment_mode', value);
								}
								setSearchPaymentMethod(value);
							}}
							onSelect={(options) => handleFormData('payment_mode', options.value)}
							error={error?.payment_mode}
							onAddNew={() => {
								setIsAddPaymentMethod(true);
								setIsPaymentMethodFocus(false);
							}}
						/>
					</div>
					<div className="col">
						<InputField
							label="Reference#"
							placeholder="REF-0008"
							type="text"
							value={paymentMadeFormData.reference_number}
							onChange={(value) => handleFormData('reference_number', value)}
						/>
					</div>
				</div>
			</div>

			{/* Order Table Section */}
			<PaymentMadeProductTable
				isDisabled={isDisabled}
				id={id}
				tableColumns={['Date', 'Bill#', 'PO#', 'Bill Amount', 'Amount Due', 'Payment']}
				handleClearAppliedAmount={handleClearAppliedAmount}
				errors={errorCells}
				productTableData={paymentMadeFormData?.purchase_bills}
				handlePaymentChange={handlePaymentChange}
				handleFullPaymentToggle={handleFullPaymentToggle}
				calculateTotalPayment={calculateTotalPayment}
				type={'pm'}
			/>
			<div className="max-w-1297 px-3 mt-3">
				{/* Summary Section */}
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'flex-start',
						padding: '10px 0px',
						backgroundColor: '#f8f9fa',
						width: '355px',
						float: 'right',

						margin: '10px 0px',
					}}
				>
					<div>
						<div className="d-flex">
							<div style={{ color: '#000000', fontWeight: '600', textAlign: 'right' }}>
								<p>Amount Paid</p>
								<p>Amount Used For Payment</p>
								<p>Amount Refunded</p>
								<p style={{ display: 'flex', justifyContent: 'end', gap: 8, alignItems: 'center' }}>
									<svg
										width="18"
										height="18"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M7.71758 2.89393L1.36508 13.4989C1.2341 13.7258 1.1648 13.9829 1.16407 14.2448C1.16334 14.5067 1.23119 14.7643 1.3609 14.9918C1.4906 15.2194 1.67762 15.409 1.90336 15.5418C2.12909 15.6746 2.38568 15.7461 2.64758 15.7489H15.3526C15.6145 15.7461 15.8711 15.6746 16.0968 15.5418C16.3225 15.409 16.5096 15.2194 16.6393 14.9918C16.769 14.7643 16.8368 14.5067 16.8361 14.2448C16.8354 13.9829 16.7661 13.7258 16.6351 13.4989L10.2826 2.89393C10.1489 2.67351 9.96062 2.49127 9.73597 2.3648C9.51133 2.23832 9.25788 2.17188 9.00008 2.17188C8.74228 2.17188 8.48882 2.23832 8.26418 2.3648C8.03954 2.49127 7.85128 2.67351 7.71758 2.89393Z"
											stroke="#BF9A18"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M9 6.75V9.75"
											stroke="#BF9A18"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
										<path
											d="M9 12.75H9.0075"
											stroke="#BF9A18"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
									Amount Excess
								</p>
							</div>
							<div style={{ marginLeft: '35px', fontWeight: '600' }}>
								<p>₹ {calculateTotalPayment()?.toFixed(2) || 'N/A'}/-</p>
								<p>₹ {calculateTotalPayment()?.toFixed(2) || 'N/A'}/-</p>
								<p>00.00/-</p>
								<p>00.00/-</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			{isAddNewVendorModalOpen && (
				<AddVendorModal
					handleFormData={handleFormData}
					vendorList={inputSelectOption.vendorList}
					setVendorList={(value) =>
						setInputSelectOption((prev) => ({
							...prev,
							vendorList: value,
						}))
					}
					onClose={() => setIsAddNewVendorModalOpen(false)}
				/>
			)}

			{isAddPaymentMethod && (
				<Modal
					className="delivery-modal"
					title="Payment Method"
					isOpen={isAddPaymentMethod}
					onClose={() => {
						setIsAddPaymentMethod(false);
						setIsPaymentMethodFocus(true);
					}}
					cancelButton={true}
				>
					<p>
						<InputField
							label="Payment Method"
							placeholder="Enter Payment Method"
							autoComplete={'Payment Method'}
							name="Payment Method"
							value={paymentMode}
							onChange={(value) => {
								if (value !== '' && value !== null) {
									setPaymentMode(value);
									setErrorPaymentMethod('');
								} else {
									setPaymentMode('');
									setErrorPaymentMethod('Please enter payment method');
								}
							}}
							required={true}
							error={errorPaymentMethod}
						/>
					</p>

					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-end',
							marginTop: '20px',
						}}
					>
						<Button
							button="Cancel"
							type="button"
							className="btn btn-danger"
							onClick={() => {
								setPaymentMode('');
								setIsAddPaymentMethod(false);
								setIsPaymentMethodFocus(true);
							}}
						/>
						<span style={{ width: '20px' }}></span>
						<Button
							button="OK"
							type="button"
							className="btn btn-primary"
							onClick={handleAddPaymentMethod}
						/>
					</div>
				</Modal>
			)}
			{isOpenPastDate && (
				<Modal
					className="delivery-modal"
					title="Confirm Past Date"
					isOpen={isOpenPastDate}
					onClose={() => cancelUsedPastDate()}
					cancelButton={true}
				>
					<p>You are creating a transaction in the past date. Do you want to continue?</p>

					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start',
							marginTop: '20px',
						}}
					>
						<Button
							button="Proceed"
							type="button"
							className="btn btn-primary"
							onClick={confirmUsedPastDate}
						/>
						<span style={{ width: '20px' }}></span>
						<Button
							button="Cancel"
							type="button"
							className="btn btn-danger"
							onClick={() => cancelUsedPastDate()}
						/>
					</div>
				</Modal>
			)}
			{isPaymentModeAutoSave && (
				<AutoSaveModal
					isOpenModel={isPaymentModeAutoSave}
					setIsOpenModel={setIsPaymentModeAutoSave}
					user={user}
					permission={'purchases.payments_made.create'}
					type={'Payment Made'}
					withoutSave={() => {
						setIsLocationBlocker(false);
						setIsPaymentModeAutoSave(false);
						setTimeout(() => {
							navigate(isNextLocation.nextLocation?.pathname);
						}, 300);
					}}

					SaveAsContinue={() => {
						setIsPaymentModeAutoSave(false);
						handleSavePaymentMade();
					}}
				/>
			)}
			<VendorDetailsDrawer
				isOpen={isVendorDetailsDrawerOpen}
				onClose={() => setIsVendorDetailsDrawerOpen(false)}
				vendor_id={paymentMadeFormData.vendor_id}
				vendorDetailsDrawerActiveOpenTab={vendorDetailsDrawerActiveOpenTab}
			/>
		</div>
	);
};

export default CreatePaymentMade;
